import { render, staticRenderFns } from "./edit-section.component.html?vue&type=template&id=947a525a&scoped=true&"
import script from "./edit-section.component.ts?vue&type=script&lang=ts&"
export * from "./edit-section.component.ts?vue&type=script&lang=ts&"
import style0 from "./edit-section.component.scss?vue&type=style&index=0&id=947a525a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947a525a",
  null
  
)

export default component.exports